import React, { useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import ReactGa from 'react-ga';
import { defaultTheme, QtcRendererProvider } from '@3plearning/question-components-library';
import { ChakraProvider, mergeThemeOverride } from '@chakra-ui/react';
import { HelmetProvider } from 'react-helmet-async';

import HeaderAndActivity from './header-and-activity';
import Spinner from '../spinner/spinner';
import ErrorHandling from '../error-handling/error-handling';
import InternetConnectivity from '../internet-connectivity/internet-connectivity';
import Modal from '../modal/modal';
import css from './mle.scss';
import { getValueFromUrl } from '../../helpers/utils';
import { fetchAssignmentDetails } from './mle-actions';
import DummyOff from '../dummy-off/dummy-off';
import { mleTheme } from '../../helpers/mle-theme';
import FooterQtc from '../footer-qtc/footer-qtc';
import { PageTitle } from '../page-title/page-title';

const Mle = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    ReactGa.initialize(window._env_.GoogleAnalyticsId);

    ReactGa.event({
      category: 'init',
      action: 'init',
      nonInteraction: true
    });
    dispatch(fetchAssignmentDetails(getValueFromUrl('assignmentId')));
  }, []);

  return (
    <Fragment>
      <HelmetProvider>
        <PageTitle />
      </HelmetProvider>
      <ChakraProvider theme={mergeThemeOverride(defaultTheme, mleTheme)}>
        <QtcRendererProvider>
          <ErrorHandling />
          <Modal />
          <InternetConnectivity />
          <DummyOff />
          <div className={css.mle}>
            <HeaderAndActivity />
            <FooterQtc />
            <Spinner />
          </div>
        </QtcRendererProvider>
      </ChakraProvider>
    </Fragment>
  );
};

export default Mle;
